export const proxyPolyfillCompat = {
  useEmulator: null,
  useFunctionsEmulator: null,
  httpsCallable: null,
};
